import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  NgControl,
  Validators
} from '@angular/forms';
import {BsDatepickerConfig, BsDaterangepickerDirective, DatepickerDateCustomClasses} from 'ngx-bootstrap/datepicker';
import * as _ from "lodash";
import * as $ from 'jquery'
import * as moment from 'moment';
import { inputValidationMessage } from 'src/shared/validator/helper';

@Component({
  selector: 'dcu-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DatePickerComponent,
    multi: true
  }]
})

export class DatePickerComponent implements OnInit, DoCheck, AfterViewInit, ControlValueAccessor, OnChanges {

  @Input() id;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() placeholder = '';
  @Input() placement = 'bottom';
  @Input() required = false;
  @Input() displayButtonRemove = false;
  @Input() isMinDate = false;
  @Input() plusDay: number;
  @Input() label = '';
  @Input() isFormatted = false;
  @Input() dateInputFormat = '';

  @Input() isDisableButton = false;

  @Input() disabledClearButton = false;

  @Output() eventEmitter = new EventEmitter();
  @Output() selectedValueChange = new EventEmitter();

  @ViewChild('clear', {static: false}) clear: ElementRef;
  @ViewChild('dp', {static: false}) datepicker: BsDaterangepickerDirective;

  isOpen = false;
  valueChange = false;
  datePickerControl = new FormControl(null);
  parentControl: AbstractControl;
  validationMessage = '';
  @Input() bsConfig: Partial<BsDatepickerConfig>;
  onChange;
  onTouch;
  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(
    private injector: Injector
  ) {
  }

  ngOnInit() {
    // set date picker config
    this.setOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.minDate && this.bsConfig) {
      this.bsConfig.minDate = this.minDate;
    }
    if (changes.maxDate && this.bsConfig) {
      this.bsConfig.maxDate = this.maxDate;
    }
  }

  ngAfterViewInit() {
    this.parentControl = this.injector.get(NgControl).control;
  }

  reset() {
    this.datePickerControl.reset();
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.datePickerControl.disable();
    } else {
      this.datePickerControl.enable();
    }
  }

  ngDoCheck() {

    if (this.parentControl && this.parentControl.invalid && this.parentControl.hasError) {
      this.validationMessage = inputValidationMessage(this.parentControl);
    }
  }

  onClearDate(value?: any) {
    if (this.parentControl && this.parentControl.status === 'DISABLED') {
      return;
    }
    if(value){
      this.datePickerControl.setValue(this.convertToDate(value));
    } else {
      this.datePickerControl.reset();
    }
    this.hideClear();
  }

  onValueChange(value: Date): void {
    if (value) {
      this.dateCustomClasses = [
        {date: new Date(), classes: []},
      ];
      setTimeout(() => {
        this.parentControl.updateValueAndValidity();
      },0);
    }
    this.showClear();
    if (this.parentControl) {
      this.parentControl.markAsTouched();
    }
    // update value onchange
    // this.onChange(value);
    // this.selectedValueChange.emit(value);
    if (this.isFormattedDate(value) && this.isFormatted) {
      const dateConvert = moment(this.convertToDate(value)).format('YYYY-MM-DD');
      this.onChange(dateConvert);
      this.selectedValueChange.emit(dateConvert);
    } else {
      this.onChange(value);
      this.selectedValueChange.emit(value);
    }
  }

  showClear() {
    $('#clear-date' + this.id).show();
  }

  hideClear() {
    $('#clear-date' + this.id).hide();
    if (this.plusDay) {
      this.dateCustomClasses = [
        {date: moment(new Date()).add(this.plusDay,'days').toDate(), classes: ['bg-primary','text-white']}
      ];
    } else {
      this.dateCustomClasses = [
        {date: new Date(), classes: ['bg-primary','text-white']},
      ];
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      if (this.datePickerControl.value !== obj) {
        if (!this.isFormattedDate(obj)) {
          const dateConvert = moment(this.convertToDate(obj)).format('YYYY-MM-DD');
          if (!moment(obj).isSame(dateConvert)) {
            this.datePickerControl.setValue(moment(obj).toDate());
          } else {
            this.datePickerControl.setValue(this.convertToDate(obj));
          }
        } else {
          this.datePickerControl.setValue(this.convertToDate(obj));
        }
      }
    } else {
      this.onClearDate();
    }
    this.setOptions();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setOptions() {
    this.bsConfig = _.assign(this.bsConfig, {
      dateInputFormat: this.dateInputFormat || 'DD/MM/YYYY',
      containerClass: 'theme-dark-blue',
      selectFromOtherMonth: true,
      adaptivePosition: true
    });
    // set min date
    if (this.isMinDate && !this.minDate) {
      if (this.plusDay) {
        this.bsConfig = Object.assign(this.bsConfig, {
          minDate: moment(new Date()).add(this.plusDay,'days').toDate()
        });
      } else {
        this.bsConfig = Object.assign(this.bsConfig, {
          minDate: new Date()
        });
      }
    } else {
      if (this.minDate) {
        this.bsConfig = Object.assign(this.bsConfig, {
          minDate: this.minDate
        });
      }

      if (this.maxDate) {
        this.bsConfig = Object.assign(this.bsConfig, {
          maxDate: this.maxDate
        });
      }
    }

    if (this.required) {
      this.datePickerControl.setValidators([Validators.required]);
    }

    // apply config to datepicker
    setTimeout(() => {
      // set config
      this.datepicker.setConfig();
      // check clear
      if (this.datePickerControl.value) {
        this.showClear();
      } else {
        this.hideClear();
      }
    },1);
  }

  private convertToDate(value: any) {
    if (_.isDate(value) && moment(value).isValid()) {
      return value;
    }

    if (_.isNull(value) || _.isEmpty(value)) {
      return null;
    }

    const timestamp = Date.parse(value);
    if (isNaN(timestamp)) {
      return null;
    }
    return new Date(value);
  }

  private isFormattedDate(value: any): boolean{
    return _.isDate(value) && moment(value).isValid();
  }
}
